import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import mandMobile from 'mand-mobile'
import 'mand-mobile/lib-vw/mand-mobile.css'
import './assets/icon/iconfont.css'
import axios from 'axios'
import {Toast, Dialog} from 'mand-mobile'
Vue.use(mandMobile)
axios.defaults.baseURL = '/manager';

Vue.prototype.$http = axios
Vue.prototype.UI = {//提示
  Toast,
  Dialog
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
